/*
 DocumentDrawer component
 url match: / or /home
 Displays overview 
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { drawerStyles } from '../../Styles/documentStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Drawer from '@material-ui/core/Drawer';
import DeleteDialog from '../Dashboard/DeleteDialog';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';


/*const StyledDrawer = styled(Drawer)`
  & > div {
    width: 16%;
  }
`; */

@inject('dashboardStore', 'documentStore', 'userStore')
@observer
class DocumentDrawer extends React.Component {
    state = {
        latestDocs: [],
        openDeleteDialog: false,
        id: ''

    }

    componentDidMount() {
        const { currentDoc } = this.props.documentStore;
        this.props.dashboardStore.fetchDocumentList(currentDoc.docStatus);
    }

    closeDrawer = () => {
        this.props.documentStore.closeDocumentDrawer();
    }

    getDocDetails = (item) => {
        if (item.aiErrorFlag || item.docStatus === 'AI_PENDING')
            return
        this.props.documentStore.getDocumentDetails(item._id)
    }

    onDelete = (id) => {
        this.setState({ openDeleteDialog: true, id: id })
    }

    confirmDelete = () => {
        this.setState({ openDeleteDialog: false })
        const { currentDoc } = this.props.documentStore;
        let temp = [];
        temp.push(this.state.id);
        this.props.dashboardStore.deleteDocument(temp, currentDoc.docStatus);
        if (this.state.id === currentDoc._id)
            this.props.history.push("/dashboard/drafts")

    }

    cancelDelete = () => {
        this.setState({ openDeleteDialog: false })
    }

    render() {
        const { classes } = this.props;
        const { openDrawer, currentDoc } = this.props.documentStore;
        const { documentList } = this.props.dashboardStore;
        const { user } = this.props.userStore;
        return (
            <ClickAwayListener onClickAway={(e) => this.closeDrawer()}>
                <Drawer
                    onClose={this.closeDrawer}
                    classes={{
                        paper: classes.documentDrawer,
                    }}
                    anchor="top"
                    open={openDrawer}
                >
                    <div style={{ padding: '0vh 1vw', paddingTop: '1vh' }}>
                        <div className={classes.closeIcon}><HighlightOffIcon className={classes.svg} onClick={(e) => this.closeDrawer()}></HighlightOffIcon></div>
                        <div className={classes.drawerContainer}>
                            Imported Documents
                    </div>
                        <div >
                            <div className={classes.imageContainer}>
                                {
                                    documentList && documentList.length
                                    && documentList.map((row, index) => {
                                        return (
                                            row.docStatus !== "AI_PENDING" && row.templateMappingFlag !== false ?
                                                <div className={classes.docDetails} key={index}>
                                                    <div className={classes.imgCont}>
                                                        <img alt={row.originalFileName} className={classes.docPreview} src={row.imagePreview} onClick={(e) => this.getDocDetails(row)}></img>

                                                    </div>
                                                    <div style={{ display: 'flex', justifyContent: row._id === currentDoc._id ? 'space-between' : 'flex-end' }}>
                                                        {row._id === currentDoc._id ? <ReactSVG style={{ marginTop: '-3vh', marginLeft: '7px' }} src={Images.edit} /> : null}
                                                        {user.userType !== 'AGENT' ? <ReactSVG onClick={(e) => this.onDelete(row._id)} className={classes.deleteIcon} src={Images.docDelete} /> : null}
                                                    </div>
                                                    <div style={{ color: 'white', fontSize: '11px', height: '30px', overflow: 'hidden' }} >{row.originalFileName}</div>
                                                    <div style={{ color: this.props.theme.palette.coolGray, fontSize: '10px' }} >{row.totalPages} pages</div>
                                                </div> : null
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div>

                        </div>
                    </div>
                    <DeleteDialog open={this.state.openDeleteDialog} cancelDelete={this.cancelDelete} delete={this.confirmDelete}></DeleteDialog>
                </Drawer>
            </ClickAwayListener>

        )
    }
}

export default withStyles(drawerStyles, { withTheme: true })(withRouter(DocumentDrawer));
